/**
 * .modal-remote-secondary
 * Hide the parent, show the next dialog
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

$(function()
{
    "use strict";

    // Trigger is registered for the remotely loaded modals
    $('.modal#remote').on('loaded.bs.modal', function (event) {
        // Remember the parent
        var parent = $(this);
        // See if something is required
        var $toggler = $('[data-remote-reload]').data('remote-toggle-disabled') || null;
        // if toggler provided
        if ($toggler) {
            // disable by default
            $('[data-remote-reload]').prop('disabled', true);
            // register change toggle behaviour
            $($toggler).on('change', function () {
                $('[data-remote-reload]').prop('disabled', !$(this).val());
            });
        }
        // Trigger action
        $('[data-remote-reload]').on('click', function (e){
            // Remove the inline data from the modal
            parent.removeData('bs.modal');
            // Disable the button in this session,
            // Add the spinner
            var $remote = $(this).data('remote-reload');
            // Compile the payload
            var $payload = {
                id:parent.find('form [name="id"]').val()
            };
            // Potentially extend our form
            var $attributes = $(this).data('remote-reload-attributes').split(',');
            // for each of attributes if provided
            $.each($attributes, function(i, field){
                $payload[field = field.trim()] = parent.find('form [name="'+ field +'"]').val() ;
            })
            // Replace data with a loader
            parent.find('.modal-content').load($remote, $payload);
        });
    });
});
